module.exports = __webpack_public_path__ + "homeStatic/img/bg4.6419d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/bg4.png
// module id = FqY6
// module chunks = 1